<template>
  <div class="grid-view">
    <div v-show="view==='list'" class="main-content">
      <search-item
        ref="searchItem"
        config-module="9212"
        :is-simple-query="false"
        :custom-sim-query-placeholder="$t('CargoMsg.Cargo_PlsInput') + ':' + ($t('CargoMsg.Cargo_AssemblyPlanNumber'))"
        :custom-search-items="customSearchItems"
        @click-more="value=>{isAdvancedQuery=value}"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="queryHandler"
      >
        <div slot="operations">
          <el-button type="success" :disabled="!selectedRow" @click="detail">{{ $t('CargoMsg.Cargo_View') }}</el-button>
        </div>
      </search-item>
      <div style="flex-grow: 1;min-height: 350px;">
        <cargo-ag-grid-wrapper
          config-module="202206074"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :show-selected-color="false"
          :check-sub-record="false"
          style="height: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="202206074"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
    <assembly-plan-detail
      v-if="view==='detail'"
      ref="assemblyPlanDetail"
      :airline-product-down-list="airlineProductDownList"
      :assembly-plan-uuid="selectedRow.uuid"
      @saveAssemblyPlanSuccess="assemblyPlanUuid => $emit('saveAssemblyPlanSuccess', assemblyPlanUuid)"
      @back="view='list'"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as RadioStatusConstants from '@/class/cargo/model/parameters/RadioStatusConstants'
import airlineProductVoyage from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyage'
import airlineProductVoyageCost from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyageCost'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { queryAssemblyPlan } from '@/api/booking/assemblyPlan'
import assemblyPlanDetail from '@/views/cargo/v0/AirExport/components/loadManagement/assemblyPlanDetail'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { isEqual } from 'lodash'

export default {
  name: 'AssemblyPlan',
  components: { cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, cargoInputNumber,
    cargoNumericStepper, airlineProductVoyage, airlineProductVoyageCost, assemblyPlanDetail },
  props: {
    airlineProductDownList: { type: Array, default: () => [] }
  },
  data() {
    return {
      SystemConstants, RadioStatusConstants,
      loading: false,
      TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      customSearchItems: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        // 行点击触发事件
        onRowClicked: this.onRowClickedHandler,
        onRowDoubleClicked: this.onRowDoubleClickedHandler
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyPlanNumber'),
          field: 'assemblyPlanNo',
          colId: 'assemblyPlanNo',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AssemblyPlanStatus'),
          field: 'status',
          colId: 'status',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.ASSEMBLY_PLAN_STATUS)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ServiceProduct'),
          field: 'serviceProduct',
          colId: 'serviceProduct',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirServiceProduct, 'productId', params.value, 'productName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineProductCode'),
          field: 'airlineProductUuid',
          colId: 'airlineProductUuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.getAirLineProductLabelFunc(params.value, this.airlineProductDownList)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Airline2'),
          field: 'carrierId',
          colId: 'carrierId',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          hide: true
        }, {
          headerName: this.$t('SeaExport.FlightNo'),
          field: 'flightNumber',
          colId: 'flightNumber',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_FlightDate'),
          field: 'flightDate',
          colId: 'flightDate',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeliveryCargoStation'),
          colId: 'cargoTerminalOperation',
          field: 'cargoTerminalOperation',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirportCargoTerminal, 'uuid', params.value, 'warehouseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OriginPort'),
          field: 'portOfDeparture',
          colId: 'portOfDeparture',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          colId: 'destinationPortCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AssemblyItemCount'),
          field: 'quantityAssembly',
          colId: 'quantityAssembly',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyGrossWeight'),
          field: 'weightAssembly',
          colId: 'weightAssembly',
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyVolume'),
          field: 'cubageAssembly',
          colId: 'cubageAssembly',
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyChargeableWeight'),
          field: 'chargeWeightAssembly',
          colId: 'chargeWeightAssembly',
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Density_Weight'),
          field: 'density',
          colId: 'density',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.getDensityLabel(params.data)
          }
        }
      ],
      rowData: [],
      selectedRows: [],
      selectedRow: null,
      gridApi: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      view: 'list'
    }
  },
  watch: {
    airlineProductDownList: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0 && !isEqual(newVal, oldVal)) {
          // 初始化 自定义 高级查询
          this.customSearchItems = this.getCustomSearchItems()
        }
      }
    }
  },
  created() {
    this.queryHandler()
    this.init()
  },
  methods: {
    init() {
      // 初始化 自定义 高级查询
      this.customSearchItems = this.getCustomSearchItems()
    },
    onRowDoubleClickedHandler(event) {
      this.selectedRow = event.data
      this.detail()
    },
    onRowClickedHandler(event) {
      this.selectedRow = event.data
    },
    getCustomSearchItems() {
      const defaultSearchFields = []
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'assemblyPlan.AIRLINE_PRODUCT_UUID'
      searchField.itemLabel = 'CargoMsg.Cargo_AirlineProductCode'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.tagName = 'name'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = this.airlineProductDownList
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    setSelectValue(obj) {
      this.airlineProductDialog.form[obj.key] = obj.value
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (!keyword) {
        // 覆盖原查询条件
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + (this.$t('CargoMsg.Cargo_AssemblyPlanNumber')))
        return
      }
      const data = [new AdvancedSearchOption(null, 'ASSEMBLY_PLAN_NO', keyword, 'LIKE').formatObj2Json()]
      this.queryHandler(data)
    },
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryAssemblyPlan(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.selectedRows = []
        this.selectedRow = null
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查看 拼装计划 详情
    detail() {
      this.view = 'detail'
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
}
</style>
